import axios from 'axios';
import * as _ from 'lodash'

class RouteService {

  /**
   *
   *
   * @returns Promise<Object>
   */
  createRoute(req) {
    return axios
      .post(`/v2/vp/createRoute`, req)
      .then(res => {
        return res.data;
      });
  }

  getRoute(status = true, search = '') {
    return axios
      .get(`/v2/vp/getRoute/${status ? 1 : 2}?search=${search}`)
      .then(res => {
        return res.data.routes;
      });
  }




}

// Singleton
const instance = new RouteService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/route.js